import axios from '../utils/axios';

export default function syncCompLogosyncCompanyLogo(adminId, data) {
    return axios.post(`/admin/${adminId}/syncCompLogo`, data);
};
